var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.075 2.333A3 3 0 0 1 3 0h18a3 3 0 0 1 2.925 2.332L12 9.621.075 2.333zM0 4.046v10.656l8.705-5.337L0 4.046zm10.142 6.199L.287 16.286A2.999 2.999 0 0 0 3 18h18a3 3 0 0 0 2.712-1.716l-9.855-6.04L12 11.379l-1.858-1.135v.001zm5.154-.879L24 14.701V4.046l-8.704 5.319v.001z"}));
}

Mail.defaultProps = {"viewBox":"0 0 24 18","style":{"enableBackground":"new 0 0 24 18"},"xmlSpace":"preserve"};

module.exports = Mail;

Mail.default = Mail;
